import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('workflow_setup'),
    wizardStepTypeOfDocs: defineMessage('type_of_docs'),
    wizardStepApprovalSteps: defineMessage('approval_steps'),
    wizardStepUsers: defineMessage('users'),
    wizardStepRequesters: defineMessage('requesters'),
    wizardStepConditions: defineMessage('conditions'),
    wizardStepPreview: defineMessage('preview'),
};
